module.exports = __webpack_public_path__ + "static/img/pDR3.3adb39b7.png";